import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime.js';
import updateLocale from 'dayjs/plugin/updateLocale.js';

declare module 'dayjs' {
  interface Dayjs {
    fromNow(withoutSuffix?: boolean): string;
    from(compared: dayjs.ConfigType, withoutSuffix?: boolean): string;
    toNow(withoutSuffix?: boolean): string;
    to(compared: dayjs.ConfigType, withoutSuffix?: boolean): string;
    updateLocale(
      localeName: string,
      customConfig: Record<string, unknown>
    ): Record<string, unknown>;
  }
}
const Dayjs = (dayjs.extend(relativeTime) as unknown as typeof dayjs).extend(updateLocale);
Dayjs.updateLocale('en', {
  relativeTime: {
    future: 'in %s',
    past: '%s ago',
    s: 'seconds',
    m: 'a minute',
    mm: '%d minutes',
    h: 'an hour',
    hh: '%d hours',
    d: 'a day',
    dd: '%d days',
    M: 'a month',
    MM: '%d months',
    y: 'a year',
    yy: '%d years'
  }
});

export default Dayjs as unknown as (
  date?: dayjs.ConfigType,
  option?: dayjs.OptionType
) => dayjs.Dayjs;
